var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 5C3.25 3.48122 4.48122 2.25 6 2.25H14C15.5188 2.25 16.75 3.48122 16.75 5V5.8125H15.25V5C15.25 4.30964 14.6904 3.75 14 3.75H6C5.30964 3.75 4.75 4.30964 4.75 5V16C4.75 16.6904 5.30964 17.25 6 17.25H6.76923V18.75H6C4.48122 18.75 3.25 17.5188 3.25 16V5Z",
    fill: "#6247E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.5H10C9.72386 8.5 9.5 8.72386 9.5 9V20C9.5 20.2761 9.72386 20.5 10 20.5H18C18.2761 20.5 18.5 20.2761 18.5 20V9C18.5 8.72386 18.2761 8.5 18 8.5ZM10 7C8.89543 7 8 7.89543 8 9V20C8 21.1046 8.89543 22 10 22H18C19.1046 22 20 21.1046 20 20V9C20 7.89543 19.1046 7 18 7H10Z",
    fill: "#6247E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bdd44b14.svg";
export { ForwardRef as ReactComponent };